var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoHorizontal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "48 48 207.5 72.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .lg {\n        fill: #8b6a4f;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "lg",
    x: 127.74,
    y: 60.26,
    width: 4.43,
    height: 28.27
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "lg",
    points: "160 84.63 145.38 60.26 139.08 60.26 139.08 88.53 143.07 88.53 143.07 64.25 157.61 88.53 164.07 88.53 164.07 60.26 160 60.26 160 84.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lg",
    d: "M191.63,81.26c0-4.79-2.84-7.09-10.19-9.13-5.76-1.59-7.27-2.92-7.27-5.32s2.48-3.63,6.29-3.63c3.46,0,7.09.89,10.28,2.13l-.62-4.25c-3.46-1.06-6.38-1.51-9.66-1.51-7.09,0-10.81,3.1-10.81,7.53,0,4.61,2.75,7,9.92,8.95,5.85,1.51,7.53,2.75,7.53,5.49s-2.3,4.17-7,4.17c-3.37,0-7.09-.8-10.72-2.22l.71,4.16c2.22.71,5.58,1.68,10.37,1.68,7.27,0,11.17-3.19,11.17-8.06Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "lg",
    x: 197.3,
    y: 60.26,
    width: 4.43,
    height: 28.27
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "lg",
    points: "236.78 84.98 236.78 75.85 249.36 75.85 249.36 72.31 232.35 72.31 232.35 88.53 253 88.53 253.53 84.98 236.78 84.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "lg",
    points: "253.26 63.89 220.43 63.89 220.43 88.53 216 88.53 216 63.89 206.43 63.89 206.96 60.26 252.82 60.26 253.26 63.89"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "lg",
    x: 128.89,
    y: 99.25,
    width: 1.56,
    height: 9.92
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "lg",
    points: "142.47 107.8 137.33 99.25 135.12 99.25 135.12 109.17 136.53 109.17 136.53 100.64 141.64 109.17 143.89 109.17 143.89 99.25 142.47 99.25 142.47 107.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "lg",
    points: "155.81 100.5 155.63 99.25 148.58 99.25 148.58 109.17 150.12 109.17 150.12 105.38 154.69 105.38 154.69 104.14 150.12 104.14 150.12 100.5 155.81 100.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lg",
    d: "M167.58,102.22c0-1.87-1.18-2.98-3.56-2.98h-4.3s0,9.92,0,9.92h1.56s0-3.93,0-3.93h2.14s2.93,3.93,2.93,3.93h1.87s-3.2-4.12-3.2-4.12c1.69-.36,2.57-1.42,2.57-2.82ZM161.24,104.01v-3.51h2.57c1.48,0,2.21.58,2.21,1.74s-.84,1.78-2.32,1.78h-2.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lg",
    d: "M175.26,99.25l-4.24,9.92h1.58s.91-2.23.91-2.23h4.9s.9,2.23.9,2.23h1.66s-4.14-9.92-4.14-9.92h-1.57ZM173.99,105.75l1.99-4.86,1.96,4.86h-3.95Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "lg",
    points: "253 104.97 191.63 104.97 191.63 103.38 252.72 103.38 253 104.97"
  }))), /*#__PURE__*/React.createElement("polygon", {
    className: "lg",
    points: "117.8 78.48 116.76 72.52 99.65 72.52 99.65 50.7 92.79 49.62 92.79 72.52 50.66 72.52 49.62 78.48 67.78 78.48 67.78 118 74.63 119.1 74.63 78.48 92.79 78.48 92.79 103.15 99.64 104.25 99.65 78.48 117.8 78.48"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoHorizontal);
export default __webpack_public_path__ + "static/media/logo-horizontal.bf2e91cd5937a045932b5dd6fd0c9fd7.svg";
export { ForwardRef as ReactComponent };